export default (top, bottom) => ({
  elementHeight: 0,
  height: 0,
  thumbHeight: 0,
  scrollPos: 0,
  mousePosition: 0,
  thumb: null,

  mouseScroll(e) {
    this.scrollPos = (e.target.scrollTop / this.elementHeight) * 100;
    this.thumb.style.setProperty('top', this.scrollPos + '%');
  },

  thumbScroll(e) {
    this.mousePosition = e.clientY;
    document.onmouseup = this.closeDragElement;
    const initPos = this.scrollPos;
    document.onmousemove = (event) => {
      this.dragThumb(event, this.mousePosition, initPos);
    };
  },

  closeDragElement() {
    document.onmouseup = null;
    document.onmousemove = null;
  },

  dragThumb(e, mousePosition, initPos) {
    const dir = mousePosition > e.clientY ? -1 : 1;
    const mouseMove = Math.abs(mousePosition - e.clientY);
    let pos =
      (mouseMove / this.thumb.parentElement.offsetHeight) * 100 * dir + initPos;
    this.scrollPos = Math.min(Math.max(pos, 0), 100 - this.thumbHeight);
    this.scrollContent();
  },

  scrollContent() {
    this.$el.parentElement.nextElementSibling.scrollTop =
      (this.elementHeight * this.scrollPos) / 100;
  },

  initScrollbar() {
    this.$el.classList.add('custom-scrollbar');
    this.$nextTick(() => {
      if (this.$el.scrollHeight > this.$el.offsetHeight) {
        this.elementHeight = this.$el.scrollHeight;
        this.height = this.$el.offsetHeight;
        this.thumbHeight = (this.height / this.elementHeight) * 100;
        this.$el.setAttribute('x-on:scroll.prevent', 'mouseScroll');
        if (
          !this.$el.firstElementChild.classList.contains(
            'custom-scrollbar__bar'
          )
        ) {
          const bar = document.createElement('div');
          const thumb = document.createElement('div');
          bar.classList.add('custom-scrollbar__bar');
          thumb.classList.add('custom-scrollbar__bar__thumb');
          bar.style.setProperty('--top', top + 'px');
          bar.style.setProperty('--bottom', bottom + 'px');
          const right = window.getComputedStyle(
            this.$el.parentElement
          ).paddingRight;
          bar.style.setProperty('right', right);
          thumb.style.setProperty('height', this.thumbHeight + '%');
          thumb.setAttribute('x-on:mousedown.prevent', 'thumbScroll');
          this.thumb = thumb;
          bar.appendChild(thumb);
          this.$el.parentElement.insertBefore(bar, this.$el);
        }
      }
    });
  },

  init() {},
});
